import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { NgTemplateAssertTypeModule } from '@recruitee/common';
import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from './../../core/core.module';
import { SelectComponent } from './select.component';

@NgModule({
  exports: [SelectComponent],
  imports: [
    NgTemplateAssertTypeModule,
    VirtualScrollerModule,
    CommonModule,
    RtUICoreOverlayModule,
    I18nModule,
    SelectComponent,
  ],
})
export class SelectModule {}

export {
  SelectComponent,
  SelectGroupedOptions,
  SelectGroupOption,
  SelectOption,
  SelectOptionValue,
  SelectOptionContext,
  GroupsTemplateContext,
  SelectListTemplateContext,
  SelectGroupedSort,
} from './select.component';
